import { render, staticRenderFns } from "./ReportMenuHistory.vue?vue&type=template&id=075c4ce9&"
import script from "./ReportMenuHistory.vue?vue&type=script&lang=js&"
export * from "./ReportMenuHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports